export const isValidStartEndDates = (startDate, endDate) => {
    if (!startDate && !endDate) {
        return true;
    }

    if ((!!startDate && !endDate) || (!!endDate && !startDate)) {
        return false;
    }
    const start = new Date(startDate);
    const end = new Date(endDate);

    if (start.getTime() === end.getTime()) {
        return false;
    }

    return start < end;
};
